/**
 * External dependencies
 */
import React, { useEffect, useState } from 'react';
import { Box, Text, Stack } from '@towersystems/towersystems-design-system';
import { connect } from 'react-redux';
import { get, map } from 'lodash';

/**
 * Internal dependencies
 */
import { getAllLocations } from 'state/locations/selectors';
import FormLabel from 'components/forms/form-label';
import FormTextInput from 'components/forms/form-text-input';
import FormSelect from 'components/forms/form-select';
import FormMultiCheckbox from 'components/forms/form-multi-checkbox';
import { getEditedLocationGroup } from 'state/location-groups/selectors';
import { editLocationGroup, saveLocationGroup } from 'state/location-groups/actions';

/**
 * Style dependencies
 */
import './styles.scss';

// the location must be loaded before using this class

const LocationGroupForm = ({ locationGroupId, locationGroup, locations, connectionLocations, connectionId, disabled, ...props }) => {
    const handleOnChange = (name, value) => {
        props.editLocationGroup(locationGroupId, {
            [name]: value,
        });
    };

    const handleOnSubmit = async (e) => {
        e.preventDefault();
        props.beforeSubmit && props.beforeSubmit(locationGroup);

        try {
            let response = await props.saveLocationGroup(locationGroupId, locationGroup);
            props.afterSuccessfullSubmit && props.afterSuccessfullSubmit(response);
        } catch (error) {}

        props.afterSubmit && props.afterSubmit();
    };

    const isShown = disabled ? 'none' : 'block';

    return (
        <form id='location-group-form' onSubmit={handleOnSubmit}>
            <Stack space='large'>
                <Box>
                    <FormLabel>Name:</FormLabel>
                    <FormTextInput
                        name='name'
                        value={get(locationGroup, 'name', '')}
                        onChange={(e) => handleOnChange(e.target.name, e.target.value)}
                    />
                </Box>
                <Box display={isShown}>
                    <FormLabel>External ID:</FormLabel>
                    <Text size='xsmall'>Unique identifier (If required) of location at eCommerce platform.</Text>
                    {(connectionLocations.length==0) && (
                    <FormTextInput
                        name='external_id'
                        value={get(locationGroup, 'external_id', '')}
                        onChange={(e) => handleOnChange(e.target.name, e.target.value)}
                        disabled = {disabled}
                    />
                    )}
                    {(connectionLocations.length>0) && (
                    <FormSelect
                        onChange={(e) => handleOnChange(e.target.name, e.target.value)}
                        name='external_id'
                        value={(get(locationGroup, 'external_id', ''))}
                    >
                        <option value='' />,
                        {map(connectionLocations, ({ number, name, connection_id }) => (
                            (connection_id == connectionId) ?
                            <option value={number} key={number}>
                                {`${name}`}
                            </option> : ''
                        ))}
                    </FormSelect>
                    )}
                </Box>
                <Box>
                    <FormLabel>Inventory locations:</FormLabel>
                    <Text size='xsmall'>
                        Choose one or more Retailer locations to sync inventory to eCommerce platform. Inventories from chosen locations will be totaled and sent to your selected location.
                    </Text>
                    <Box marginTop='medium'>
                        <FormMultiCheckbox
                            onChange={(values) => handleOnChange('locations', values)}
                            defaultChecked={get(locationGroup, 'locations')}
                            options={map(locations, (location) => {
                                return {
                                    value: location.id,
                                    label: location.name,
                                };
                            })}
                        />
                    </Box>
                </Box>
            </Stack>
        </form>
    );
};

export default connect(
    (state, ownProps) => ({
        locations: getAllLocations(state),
    }),
    {
        editLocationGroup,
        saveLocationGroup,
    },
)(LocationGroupForm);
